import React, { useEffect, useState } from "react";
import {
  Container,
  ModalBody,
  Modal,
} from "reactstrap";
import { DataGrid } from "@mui/x-data-grid";
import { Box, TextField } from "@mui/material";
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import { detailed_approval_list, management_approve_product } from "../../../api/requisition";
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import ViewAndEdit from "./ViewAndEdit";
import ApprovalPending from "./ApprovalPending";


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ApprovalRequisitionDetails = () => {
  const dispatch = useDispatch();
  dispatch(StorePageHeaderName('Approval Details Requisition'));

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const navigate = useNavigate();
  const location = useLocation();
  const approvalDetails = location.state;

  const goToApprovalRequisition = () => {
    navigate("/management/approval-requisition");
  };

  document.title = "Approval Requisition details";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div>
            <div>
              <div>
                <div
                  className="mb-3"
                  style={{ fontSize: "20px", fontWeight: "500" }}
                >
                  <span
                    className="me-2"
                    onClick={goToApprovalRequisition}
                    style={{ cursor: "pointer" }}
                  >
                    <ArrowBackIcon />
                  </span>
                  <span>{approvalDetails.vendor_name}</span>
                </div>
              </div>
            </div>
            <Box sx={{ width: '100%' }}>
            <Box sx={{backgroundColor:"white" }}>
              <Tabs value={value} onChange={handleChange}>
                <Tab label="View and Edit"  {...a11yProps(0)} />
                <Tab label="Approval Pending"  {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel className="tabs_padding" value={value} index={0}>
              <ViewAndEdit approvalDetails={approvalDetails} />
            </CustomTabPanel>
            <CustomTabPanel className="tabs_padding" value={value} index={1}>
            <ApprovalPending approvalDetails={approvalDetails} />

            </CustomTabPanel>
          </Box>
          </div>
        </Container>
      </div>
      
    </React.Fragment>
  );
};

export default ApprovalRequisitionDetails;
